import {t} from "PlattixUI/PlattixReactCore/i18n";

export function NotFoundError(){
    return <h1>{t('Error.404.Msg')}</h1>
}